import { Controller } from "@hotwired/stimulus"

// Swaps every [data-es]/[data-en] node's textContent to the active language in
// place and persists the choice. Defaults to ES; falls back to ES when an
// element lacks a translation for the requested language.
const STORAGE_KEY = "lang"
const DEFAULT_LANG = "es"

export default class extends Controller {
  connect() {
    const saved = this.readSaved()
    if (saved && saved !== DEFAULT_LANG) {
      this.apply(saved)
    }
    this.reflect(this.currentLang())
  }

  set(event) {
    const lang = event.params.lang
    if (!lang) return
    this.apply(lang)
    this.persist(lang)
  }

  apply(lang) {
    document.documentElement.lang = lang
    document.querySelectorAll("[data-es],[data-en]").forEach((el) => {
      const text = el.dataset[lang] || el.dataset.es
      if (text != null) el.textContent = text
    })
    this.reflect(lang)
  }

  reflect(lang) {
    this.element.querySelectorAll("[data-lang]").forEach((btn) => {
      btn.setAttribute("aria-pressed", btn.dataset.lang === lang ? "true" : "false")
    })
  }

  currentLang() {
    return document.documentElement.lang || this.readSaved() || DEFAULT_LANG
  }

  readSaved() {
    try { return localStorage.getItem(STORAGE_KEY) } catch (_) { return null }
  }

  persist(lang) {
    try { localStorage.setItem(STORAGE_KEY, lang) } catch (_) { /* ignore */ }
  }
}
